module.exports = __webpack_public_path__ + "img/worksbot_img19112511.c6c3b921.jpg";